module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_24.c125fc53.png";